/**
 * 预警计划一览
 * 创建时间：2017-02-22
 * 创建人：baixx
 */
<template>	
	<div class="wrapper-content animated fadeInRight tabBox" id="device-instruction">
		<div class="ibox-content h100pp">
			<div class="row  h100pp">
				<div class="form-horizontal h100pp">
					<div class="col-sm-2 gray_right02a h100pp">
						<div class="form-group">
							<div class="col-sm-12">
								<input type="text" class="form-control" v-model="deviceType"  placeholder="快速查询设备类型">
							</div>
						</div>
						<ul class="list-group almoverdd">
						   <li><span>设备类型</span></li>
						    <li :id="index" @mouseenter="enter(index)" @mouseleave="leave(index)" @click="deviceTypeClick(item,index)" v-for="(item,index) in filterShoppingList" class="list-group-item">
						       <span>{{item.categoryNo}}</span>
						    </li>
						</ul>
					</div>
					<div class="col-sm-10 gray_left02 h100pp">   
						
						<div class="col-sm-8 col-sm-offset-2 text-center btn_tab">      
						    <div class="col-sm-6 h40px btn_btn cmdTitle" v-bind:class="{ 'btn-primary': iscmdActive }" @click="dictateClick(1)">设备及指令设置</div>
						    <div class="col-sm-6 h40px btn_btn almTitle" v-bind:class="{ 'btn-primary': isDeviceActive }" @click="dictateClick(2)">设备及预警设置</div>
		                </div>
		                <div v-show="iscmdActive==true" style="height: calc(100% - 150px);">
			                <div class="col-sm-6 h100pp">
				               <div class="col-sm-12 text-center h100pp">
				                    <!--表格开始-->
									<div class="table-responsive almoverdd h100pp">
										<table class="table table-bordered table-hover">
											<thead>
												<tr>
													<th onselectstart="return false;" class="text-center">未选指令类型</th>
												</tr>
											</thead>
											<tbody>
												<tr class="text-center" v-for="(item,index) in unselectedInstructionArr" v-bind:key="index">
													<td :id="index+'unselect'" v-on:dblclick="unselectedInstructionClick(index)" onselectstart="return false;">{{index ==0?'网络指令':item.cmdName}}</td>
												</tr>                                                    
											</tbody>
										</table>
									</div>
					            <!--<ul class="list-group almoverdd">
									    <li @click="ddTest(index)" v-for="(item,index) in item" class="list-group-item dd center_t">
									        <span>{{item.deviceTypeTitle}}</span>
									    </li>
									    <li v-on:dblclick="ddTest(index)" v-for="(item,index) in item" class="list-group-item">
									        <span>{{item.shoppingList[index].deviceTypeContent}}</span>
									    </li>
									</ul>-->
								</div>
				            </div>
				            <div class="col-sm-6 h100pp">
				                <div class="col-sm-12 text-center h100pp">
				                	<!--表格开始-->
									<div class="table-responsive almoverdd h100pp">
										<table class="table table-bordered table-hover">
											<thead>
												<tr>
													<th onselectstart="return false;" class="text-center">已选指令类型</th>
													<th onselectstart="return false;" class="text-center">窗口id</th>
													<th onselectstart="return false;" class="text-center">指令</th>
													<th onselectstart="return false;" class="text-center">备注</th>
												</tr>
											</thead>
											<tbody>
												<tr class="text-center" v-for="(item,index) in selectInstructionArr" v-bind:key="index">
													<td :id="index+'select'" v-on:dblclick="selectedInstructionClick(index)" onselectstart="return false;">{{index ==0?'网络指令':item.cmdName}}</td>
													<td><input v-show="index!=0" type="text" class="form-control" v-model="item.winId"></td>
													<td><input v-show="index!=0" type="text" class="form-control" v-model="item.clientCmd"></td>
													<td><input v-show="index!=0" type="text" class="form-control" v-model="item.memo" readonly></td>
												</tr>
											</tbody>
										</table>
									</div> 
				                    <!--<ul class="list-group almoverdd">
										<li @click="ddTest(index)" v-for="(item,index) in selectInstructionArr" class="list-group-item">
										    <span><input v-show="index!=0" type="text" class="form-control" v-model="item.winId"></span>
										</li>
									</ul>-->
								</div>
								
							</div>
						</div>
			            <div v-show="iscmdActive==false" style="height: calc(100% - 150px);">
			                <div class="col-sm-6 h100pp">
				               <div class="col-sm-12 text-center h100pp">
					                <!--表格开始-->
									<div class="table-responsive almoverdd h100pp">
										<table class="table table-bordered table-hover">
											<thead>
												<tr>
													<th onselectstart="return false;" class="text-center">未选预警类型</th>
												</tr>
											</thead>
											<tbody>
												<tr class="text-center" v-for="(fileInfo,index) in unselectedDeviceAlmArr" v-bind:key="index">
													<td v-on:dblclick="unselectedDeviceAlmClick(index)" onselectstart="return false;">{{fileInfo.almTypeName}}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
				            </div>
				            <div class="col-sm-6 h100pp">
				                <div class="col-sm-12 text-center h100pp">
				                <!--表格开始-->
									<div class="table-responsive almoverdd h100pp">
										<table class="table table-bordered table-hover">
											<thead>
												<tr>
													<th onselectstart="return false;" class="text-center">已选预警类型</th>
												</tr>
											</thead>
											<tbody>
												<tr class="text-center" v-for="(fileInfo,index) in selectedDeviceAlmArr" v-bind:key="index">
													<td v-on:dblclick="selectedDeviceAlmClick(index)" onselectstart="return false;">{{fileInfo.almTypeName}}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
								
							</div>
						</div>
						<div class="form-group col-sm-12">
							</br>
							<div class="col-sm-4 text-right">
							    <button type="button" @click="saveMessage" class="btn btn-primary">确定</button>
							</div>
									
							<div class="col-sm-4 text-right">
							    <button type="button" @click="resertMessage" class="btn btn-primary">重置</button>
							</div>
						 </div>	
		            </div>
				</div>
	        </div>	
	    </div>
	     <!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>	
</template>

<script>
	import TabModal from 'components/common/TabModal'
	import classlist from 'util/classlist'
	import { OPERATE_EXCEPTION } from 'static/message'
	export default {
		name: 'PageDeviceInstruction',
		components: {
			TabModal
		},
		data() {
			return {
				styleArr:[],
				instructionStatus:true,           //指令状态判断
				alarmStatus:true,                 //预警状态判断
				iscmdActive:true,
				isDeviceActive:false,
				messageStr: "",					  // 弹出框内容
				scrollTop: '0',	
				deviceType:"",                    //设备搜索条件 
				categoryId:"",                    //设备类型id
				categoryName:"",                  //设备类型name
                unselectedInstructionArr:[],      //指令未选
                selectInstructionArr:[],          //指令已选
                unselectedDeviceAlmArr:[],      //设备预警未选
                selectedDeviceAlmArr:[],          //设备预警已选
				shoppingList:[],                //获取设备类型
			};
		},
		beforeMount(){
			//获得设备类型
		     this.getproduct();
		},
		computed: {
	        filterShoppingList: function () {
		        var newArr = this.shoppingList
				    .filter(item => item.categoryNo.toLowerCase().indexOf(this.deviceType.toLowerCase()) != -1)
				    .map(item => item);
				 return newArr
	        },
	    },
		methods:{
			enter(index){
				var e = document.getElementById(index)
				$(e).addClass("feiltback")
			},
			leave(index){
				var lookSame = this.styleArr.filter(n=>n==index);
				if(lookSame.length ==0){
					var e = document.getElementById(index)
					$(e).removeClass("feiltback")
				}
			},
			//获得设备类型
			deviceTypeClick(device,index){
				var e = document.getElementById(index)
				$(e).siblings().removeClass("active")
				$(e).siblings().removeClass("feiltback")
				$(e).addClass("active")
				this.styleArr = [];
				this.styleArr.push(index)
				//e.setAttribute("class", "list-group-item active"); 
				this.categoryId = device.categoryId
				this.categoryName = device.categoryNo
				this.instructionStatus = true;
				this.alarmStatus = true;
				this.deviceTypeCom();
				this.alarmTypeCom();
			},	
			//获取指令类型共通
			deviceTypeCom(){
				this.$http.get(process.env.API_ROOT + '/system/category/'+this.categoryId+'/cmds')
				.then(res => {
					if(res.body.success) {
						this.unselectedInstructionArr = [];
						this.unselectedInstructionArr.push("网络指令")
						for (var i=0;i<res.body.data.allData.length;i++){
							this.unselectedInstructionArr.push(res.body.data.allData[i])
						}
						this.selectInstructionArr = [];
						if(res.body.data.selData.length !=0){
							this.selectInstructionArr.push("网络指令")
							for (var i=0;i<res.body.data.selData.length;i++){
							this.selectInstructionArr.push(res.body.data.selData[i])
						   }
						}
						
						setTimeout(() => {
							var unselectIns = document.getElementById("0unselect")
							var selectIns = document.getElementById("0select")
							if(unselectIns &&!unselectIns.className){
								$(unselectIns).addClass("instruction")
							}
							if(selectIns &&!selectIns.className){
								$(selectIns).addClass("instruction")
							}
				         });
				
					} else {
						this.openModalMsg(res.data.message);
					}
				}, res => {
					this.openModalMsg(res.data.message);
				}).catch(res => {
					this.openModalMsg(OPERATE_EXCEPTION);
				})
			},
		    //获取预警类型设置共通
		    alarmTypeCom(){
		    	this.$http.get(process.env.API_ROOT + '/system/category/'+this.categoryId+'/alarms')
					.then(res => {
						if(res.body.success) {
							this.unselectedDeviceAlmArr = res.body.data.allData
							this.selectedDeviceAlmArr = res.body.data.selData
						} else {
							this.openModalMsg(res.data.message);
						}
					}, res => {
						this.openModalMsg(res.data.message);
					}).catch(res => {
						this.openModalMsg(OPERATE_EXCEPTION);
				})
		    },
			//指令未选双击
			 unselectedInstructionClick(index){
			 	if(index!=0){
			 		this.instructionStatus = false;
			 		if(this.selectInstructionArr.length==0){
			 			this.selectInstructionArr.push("网络指令")
			 			this.unselectedInstructionCom(index)
			 		}
			 		else{
			 			this.unselectedInstructionCom(index)
			 	        if(this.unselectedInstructionArr.length==1){
		            		this.unselectedInstructionArr = [];
		            	}
			 		}
		 			setTimeout(() => {
						var selectIns = document.getElementById("0select")
						if(selectIns &&!selectIns.className){
							$(selectIns).addClass("instruction")
						}
			        });
			 	}
            },
            //指令共通
            unselectedInstructionCom(index){
            	let instr = {};
	 			instr.cmdId = this.unselectedInstructionArr[index].cmdId
	 			instr.cmdType = this.unselectedInstructionArr[index].cmdType 
	 			instr.cmdTypeName = this.unselectedInstructionArr[index].cmdTypeName
	 			instr.cmdName = this.unselectedInstructionArr[index].cmdName
	 			instr.memo = this.categoryName+"--"+this.unselectedInstructionArr[index].cmdName
	 			this.selectInstructionArr.push(instr)
	 	        this.unselectedInstructionArr.splice(index, 1);
            },
            //指令已选双击
            selectedInstructionClick(index){
            	if(index!=0){
            		this.instructionStatus = false;
            		if(this.unselectedInstructionArr.length==0){
            			this.unselectedInstructionArr.push("网络指令")
            			this.unselectedInstructionArr.push(this.selectInstructionArr[index])
			 	        this.selectInstructionArr.splice(index, 1);
            		}
            		else{
            			this.unselectedInstructionArr.push(this.selectInstructionArr[index])
		            	this.selectInstructionArr.splice(index, 1);
		            	if(this.selectInstructionArr.length==1){
		            		this.selectInstructionArr = [];
		            	}
            		}
        			setTimeout(() => {
						var unselectIns = document.getElementById("0unselect")
						if(unselectIns &&!unselectIns.className){
							$(unselectIns).addClass("instruction")
						}
			        });
            	}
            },
            
            //设备预警未选双击
			 unselectedDeviceAlmClick(index){
			 	this.alarmStatus = false;
			 	this.selectedDeviceAlmArr.push(this.unselectedDeviceAlmArr[index])
			 	this.unselectedDeviceAlmArr.splice(index, 1);
            },
            //设备预警已选双击
            selectedDeviceAlmClick(index){
            	this.alarmStatus = false;
            	this.unselectedDeviceAlmArr.push(this.selectedDeviceAlmArr[index])
            	this.selectedDeviceAlmArr.splice(index, 1);
            },
            //信息保存
            saveMessage(){
            	//指令保存
               if(this.iscmdActive == true){
            		this.resulertArr = [];
            		if(this.selectInstructionArr.length==0){
            			this.openModalMsg("设置指令不能为空");
            			return;
            		}
            		
	            	for (var i=0;i<this.selectInstructionArr.length;i++){
						let info = Object.assign({},'');
						info.categoryId = this.categoryId
						info.clientCmd = this.selectInstructionArr[i].clientCmd
						info.cmdId = this.selectInstructionArr[i].cmdId
						info.memo = this.selectInstructionArr[i].memo
						info.cmdType = this.selectInstructionArr[i].cmdType
						info.winId = this.selectInstructionArr[i].winId
					    this.resulertArr.push(info);
					    if(i!=0 &&(!this.selectInstructionArr[i].clientCmd &&!this.selectInstructionArr[i].winId)){
					    	this.openModalMsg("窗口id或指令不能为空");
					    	return;
					    }
					}
	            	this.resulertArr.splice(0, 1);
	            	this.$http.post(process.env.API_ROOT +'/system/category/'+this.categoryId+'/cmd',this.resulertArr)
					.then(res => {
						if(res.body.success) {
						     this.openModalMsg("保存成功");
						} else {
							this.openModalMsg(res.data.message);
						}
					}, res => {
						this.openModalMsg(res.data.message);
					}).catch(res => {
						this.openModalMsg(OPERATE_EXCEPTION);
					})
            	}else{
            		this.resulertAlarmArr = [];
	            	for (var i=0;i<this.selectedDeviceAlmArr.length;i++){
						let info = Object.assign({},'');
						info.categoryId = this.categoryId
						info.almType = this.selectedDeviceAlmArr[i].almType
					    this.resulertAlarmArr.push(info);
					}
	            	this.$http.post(process.env.API_ROOT +'/system/category/'+this.categoryId+'/alarms',this.resulertAlarmArr)
					.then(res => {
						if(res.body.success) {
						     this.openModalMsg("保存成功");
						} else {
							this.openModalMsg(res.data.message);
						}
					}, res => {
						this.openModalMsg(res.data.message);
					}).catch(res => {
						this.openModalMsg(OPERATE_EXCEPTION);
					})
            	}
            },
            //重置
            resertMessage(){
            	if(this.iscmdActive == true){
            		for(var i = 0; i < this.selectInstructionArr.length; i++) {
            			if(i!=0){
            				this.unselectedInstructionArr.push(this.selectInstructionArr[i])
            			}
            	   }
            		 this.selectInstructionArr=[];
            	}else{
            		for(var i = 0; i < this.selectedDeviceAlmArr.length; i++) {
            	     this.unselectedDeviceAlmArr.push(this.selectedDeviceAlmArr[i])
            	   }
            		this.selectedDeviceAlmArr=[];
            	}
            },
            //tab切换
			 dictateClick(level){
			 	if(level == 1){
			 		this.iscmdActive = true;
			 	    this.isDeviceActive = false;
			 	    if(this.categoryId && this.instructionStatus){
			 	    	this.deviceTypeCom();
			 	    }
			 	}else{
			 		this.iscmdActive = false;
			 	    this.isDeviceActive = true;
			 	     if(this.categoryId && this.alarmStatus){
			 	    	this.alarmTypeCom();
			 	    }
				}
    	    },
			//获得设备类型
			getproduct(){
				this.$http.get(process.env.API_ROOT + '/system/category/categorys')
				.then(res => {
					if(res.body.success) {
						this.shoppingList = res.body.data;
					} else {
						this.openModalMsg(res.data.message);
					}
				}, res => {
					this.openModalMsg(res.data.message);
				}).catch(res => {
					this.openModalMsg(OPERATE_EXCEPTION);
				})
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#device-instruction',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#device-instruction',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},
		}
	};

</script>
<style scoped>
div .almoverdd {
    width: 100%;
    overflow: scroll;
}

.cmdTitle,.almTitle{
	border:1px solid #D2F0EA
}
.instruction{
	background-color: #F5F5F5;
}
.feiltback{
	background-color: #B0C4DE;
}
.center_t { padding: 15px 0; }
.btn_tab { padding: 20px 0; }
.btn_btn { line-height: 40px;}
.gray_right02a { overflow: auto; padding-right: 10px;} 
</style>


// WEBPACK FOOTER //
// PageDeviceInstruction.vue?6cab36d8